module.exports = __webpack_public_path__ + "img/引导按钮2.e48cff25.webp";